import { Card, CardProps } from "../../../../components/Card"
import { FCC } from "../../../../utils/reactHelpers/types"

export const CompactCard: FCC<CardProps> = props => (
  <Card boxClassName={"p-3"} {...props} />
)
